export default __webpack_public_path__ + "static/media/548.4565791b.png";